module.exports = __webpack_public_path__ + "assets/img/cc656c3d72d0fe2970bdc13320fe6522.svg";